<div class="popup-specification">
  <ng-container>
    <nb-card class="nb-card" [nbSpinner]="loading" nbSpinnerStatus="info">
      <nb-card-body>
        <h6>Логирование затраченного времени</h6>
        <form class="b-form" [formGroup]="form" (submit)="save()">
          <div class="box-modal modal-block-space">
            <div class="row">
              <div class="col-3">
                <tui-input-date toNativeDate
                                tuiTextfieldSize="l"
                                formControlName="date">
                  Дата
                </tui-input-date>
              </div>
              <div class="col-3">
                <tui-input formControlName="diffTime" [(ngModel)]="durationHeader" (change)="changeDiffTime()">
                  Длительность
                  <input
                    tuiTextfieldLegacy
                    #diffTime
                    ngxDuration
                    nbInput
                  />
                </tui-input>
              </div>
              <div class="col-3">
                <div class="box-modal">
                  <tui-input-time
                    tuiUnfinishedValidator
                    (focusedChange)="changeInputStart()"
                    [items]="timePeriods"
                    formControlName="startTime">
                    Начало работы
                  </tui-input-time>
                </div>
              </div>
              <div class="col-3">
                <div class="box-modal">
                  <tui-input-time
                    tuiUnfinishedValidator
                    (focusedChange)="changeInputEnd()"
                    [items]="timePeriods"
                    formControlName="endTime">
                    Конец работы
                  </tui-input-time>
                </div>
              </div>
            </div>
            <p class="sample">h - часы, m - минуты. пример - <span class="badge">3 h</span>, <span class="badge">20 m</span>, <span class="badge">4 h 20 m</span></p>
          </div>
          <div class="box-modal modal-block-space">
            <app-issue-search-elastic
              typeCallback="event"
              [issue]="issue"
              [canRemoveTask]="canRemoveTask"
              (onSelectIssue)="setIssue($event)">
            </app-issue-search-elastic>
          </div>
          <div class="row">
            <div class="col-12">
              <tui-input
                tuiTextfieldSize="l"
                formControlName="content"
              >
                Описание выполненой работы
              </tui-input>

            </div>
          </div>
          <p class="error">
            {{ getLogtimeError() }}
          </p>
          <p>
            <button nbButton [disabled]="!isValid()">
              <ng-container *ngIf="jobId">Изменить запись</ng-container>
              <ng-container *ngIf="!jobId">Записать время</ng-container>
            </button>
          </p>
        </form>
      </nb-card-body>
    </nb-card>
  </ng-container>
</div>
